<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">{{ title }}</span>
      <v-spacer/>
      <Icon
        dataTestId="trailer-identifier-close"
        iconColor="white"
        icon="mdi-close"
        :small="false"
        :large="true"
        :tooltipText="$t('close')"
        @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text>
      <FormWrapper
        ref="form"
        formRef="trailerIdentifierForm"
        :buttonText="submitBtnText"
        @submit="saveChangesPressed"
      >
        <v-container fluid grid-list-xl>
          <v-row class="mt-1">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="trailerIdentifier.value"
                data-testid="trailer-identifier-value"
                ref="firstField"
                color="black"
                :maxlength="10"
                counter="10"
                type="number"
                hide-spin-buttons
                :label="$t('trailerIdentifierValue')"
                :rules="[rules.required, validateTrailerIdentifier]"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="trailerIdentifier.vehicleType"
                :items="vehicleTypeOptions"
                item-text="name"
                item-value="value"
                :label="$t('vehicleType')"
                color="black"
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import fieldRules from '@/utils/rules.js'
import { VehicleType } from '@/utils/Enumerations'

export default {
  name: 'TrailerIdentifierForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  props: {
    propTrailerIdentifier: {
      type: Object,
      default: undefined
    }
  },

  data: () => ({
    rules: fieldRules.rules,
    trailerIdentifier: {
      value: '',
      vehicleType: VehicleType.Trailer.value
    }
  }),

  computed: {
    submitBtnText () {
      return this.propTrailerIdentifier ? this.$t('saveChanges') : this.$t('createTrailerIdentifier')
    },

    title () {
      return this.propTrailerIdentifier ? this.$t('editingTrailerIdentifier') : this.$t('creatingTrailerIdentifier')
    },

    vehicleTypeOptions () {
      return VehicleType.enums
    },

    isEditing () {
      return !!this.propTrailerIdentifier
    }
  },

  created () {
    if (this.propTrailerIdentifier) {
      this.trailerIdentifier = { ...this.propTrailerIdentifier }
    }
  },

  mounted () {
    setTimeout(() => {
      if (this.$refs.firstField) {
        this.$refs.firstField.focus()
      }
    }, 0)
  },

  methods: {
    validateTrailerIdentifier (value) {
      if (value == null || String(value).trim() === '') {
        return true
      }

      const trailerIdentifier = String(value).trim()
      const isValid = /^[1-9]\d*$/.test(trailerIdentifier) && trailerIdentifier.length <= 10
      return isValid || this.$t('invalidAccountTrailerId')
    },

    saveChangesPressed () {
      if (this.isEditing) {
        this.$emit('trailer-identifier-updated', this.trailerIdentifier)
      } else {
        this.$emit('trailer-identifier-created', this.trailerIdentifier)
      }
    }
  }
}
</script>
